export class Shipper{
    public Id : Number;
    public IsActive : Boolean = true;
    public Code : String;
    public Name : String;
    public Address : String;
    public PostalCodeId : Number = 0;
    public CityId : Number = 0;
    public CountryId : Number = 0;
    public Website : String;
    public VAT : String;
    public ContactPerson : String;
    public Phone : String;
    public Email: String;
    public DeliveryCondition: String;
}


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/models/shipper.model.ts